var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 44C50 47.3137 47.3137 50 44 50C40.6863 50 38 47.3137 38 44C38 40.6863 40.6863 38 44 38C47.3137 38 50 40.6863 50 44Z",
    fill: "#00A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4482 24L56.9123 26L45.9888 44.9202L42.5247 42.9202L53.4482 24Z",
    fill: "#00A88E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 46L30 42L46 42L46 46L30 46Z",
    fill: "#00A88E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 74C60.5685 74 74 60.5685 74 44C74 27.4315 60.5685 14 44 14C27.4315 14 14 27.4315 14 44C14 60.5685 27.4315 74 44 74ZM44 78C62.7777 78 78 62.7777 78 44C78 25.2223 62.7777 10 44 10C25.2223 10 10 25.2223 10 44C10 62.7777 25.2223 78 44 78Z",
    fill: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 4H46V20H42V4Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 4V20H46V4H42Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84 42L84 46L68 46L68 42L84 42Z",
    fill: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 42L68 42L68 46L84 46L84 42Z",
    fill: "#1D1D1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 68H46V84H42V68Z",
    fill: "#1D1D1B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 68V84H46V68H42Z",
    fill: "#1D1D1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42L20 46L4 46L4 42L20 42Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 42L4 42L4 46L20 46L20 42Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.2c9ccfe4f5455168c6e15704a35433e6.svg";
export { ForwardRef as ReactComponent };